import {
  TOGGLE_SIDEBAR,
  REQUEST_REPAIRE_FORM,
  RECEIVE_REPAIRE_FORM,
  REQUEST_CREATE_TICKET,
  RECEIVE_CREATE_TICKET,
  REQUEST_MY_TICKET_LIST,
  RECEIVE_MY_TICKET_LIST,
  REQUEST_TICKET_DETAIL,
  RECEIVE_TICKET_DETAIL,
  REQUEST_USER_INFO,
  RECEIVE_USER_INFO,
  REQUEST_SAVE_USER_INFO,
  RECEIVE_SAVE_USER_INFO,
  REQUEST_CHANGE_PASSWORD,
  RECEIVE_CHANGE_PASSWORD,
  REQUEST_COMMON_FAULT,
  RECEIVE_COMMON_FAULT,
  REQUEST_SERVICE_TICKET_DETAIL,
  RECEIVE_SERVICE_TICKET_DETAIL,
  REQUEST_QUERY_DEVICEINFO,
  RECEIVE_QUERY_DEVICEINFO,
  RECEIVE_QUERY_DEVICEINFO_FAIL,
  REQUEST_FETCH_SP_INFO,
  RECEIVE_FETCH_SP_INFO,
  REQUEST_FETCH_TICKET_STEPS,
  RECEIVE_FETCH_TICKET_STEPS,
} from './mutation-types';

export default {
  [TOGGLE_SIDEBAR](state) {
    state.sidebarVisible = !state.sidebarVisible
  },
  [REQUEST_REPAIRE_FORM](state) {
    state.report.loading = true;
    state.report.saving = false;
  },
  [RECEIVE_REPAIRE_FORM](state, payload) {
    state.report.loading = false;
    state.report.saving = false;
    state.report.form_html = payload;
  },
  [REQUEST_CREATE_TICKET](state) {
    state.report.loading = false;
    state.report.saving = true;
  },
  [RECEIVE_CREATE_TICKET](state) {
    state.report.loading = false;
    state.report.saving = false;
  },
  [REQUEST_MY_TICKET_LIST](state) {
    state.report_list.loading = true;
  },
  [RECEIVE_MY_TICKET_LIST](state, payload) {
    state.report_list.loading = false;
    state.report_list.columns = payload.column_map;
    state.report_list.data = payload.collection;
    state.report_list.total = payload.total_records;
    state.report_list.additional_parameters = payload.additional_parameters || {};
  },
  [REQUEST_TICKET_DETAIL](state) {
    state.report_detail.loading = true;
  },
  [RECEIVE_TICKET_DETAIL](state, payload) {
    state.report_detail.loading = false;
    state.report_detail.ticket = payload.html;
    state.report_detail.no = payload.no;
    state.report_detail.videos = payload.videos;
    state.report_detail.voices = payload.voices;
    state.report_detail.attachments = payload.attachments;
  },
  [REQUEST_USER_INFO](state) {
    state.info.loading = true;
    state.info.saving = false;
  },
  [RECEIVE_USER_INFO](state, payload) {
    state.info.loading = false;
    state.info.saving = false;

    state.info.user_name = payload.user_name;
    state.info.is_verified = payload.is_verified;
  },
  [REQUEST_SAVE_USER_INFO](state) {
    state.info.loading = false;
    state.info.saving = true;
  },
  [RECEIVE_SAVE_USER_INFO](state, payload) {
    state.info.loading = false;
    state.info.saving = false;

    state.info.user_name = payload.user_name;
  },
  [REQUEST_CHANGE_PASSWORD](state) {
    state.info.saving = true;
  },
  [RECEIVE_CHANGE_PASSWORD](state) {
    state.info.saving = false;
  },
  [REQUEST_COMMON_FAULT](state) {
    state.report.common_fault_loading = true;
    state.report.common_fault = [];
  },
  [RECEIVE_COMMON_FAULT](state, payload) {
    state.report.common_fault_loading = false;
    state.report.common_fault = payload;
  },
  [REQUEST_SERVICE_TICKET_DETAIL](state) {
    state.report_detail.loading = true;
    state.report_detail.service_ticket_loaded = false;
    state.report_detail.service_ticket = null;
  },
  [RECEIVE_SERVICE_TICKET_DETAIL](state, payload) {
    state.report_detail.loading = false;
    state.report_detail.service_ticket_loaded = true;
    state.report_detail.service_ticket = payload;
  },
  [REQUEST_FETCH_SP_INFO](state) {
    state.report_query.querying = true;
  },
  [RECEIVE_FETCH_SP_INFO](state, payload) {
    state.report_query.querying = false;
    state.report_query.can_report_directly = payload && payload.setting && payload.setting.can_report_directly;
  },
  [REQUEST_QUERY_DEVICEINFO](state) {
    state.report_query.querying = true;
  },
  [RECEIVE_QUERY_DEVICEINFO](state, payload) {
    state.report_query.querying = false;
    state.company_info.name = payload.name;
    state.company_info.link_man = payload.link_man;
    state.company_info.cus_dept = payload.cus_dept;
  },
  [RECEIVE_QUERY_DEVICEINFO_FAIL](state) {
    state.report_query.querying = false;
  },
  [REQUEST_FETCH_TICKET_STEPS](state) {
    state.report_steps.querying = true;
    state.report_steps.steps = [];
    state.report_steps.current = 0;
  },
  [RECEIVE_FETCH_TICKET_STEPS](state, payload) {
    state.report_steps.querying = false;
    if (payload) {
      state.report_steps.steps = payload.steps;
      state.report_steps.current = payload.current_step;
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js